import React, { createContext, useContext, useMemo, useRef } from 'react';
const ScrollContext = /*#__PURE__*/ createContext(undefined);
export const ScrollProvider = ({ children })=>{
    const scrollViewRef = useRef(null);
    const value = useMemo(()=>({
            scrollTo: (element)=>{
                if (element && scrollViewRef.current) {
                    const { top, bottom } = element.getBoundingClientRect();
                    const { innerHeight } = window;
                    // A cell taller than the viewport is left alone once its top is
                    // visible, otherwise centring it would hide its top again.
                    const isCutOffAtBottom = bottom > innerHeight && bottom - top <= innerHeight;
                    if (top < 0 || top > innerHeight || isCutOffAtBottom) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                }
            }
        }), []);
    return /*#__PURE__*/ React.createElement("div", {
        ref: scrollViewRef
    }, /*#__PURE__*/ React.createElement(ScrollContext.Provider, {
        value: value
    }, children));
};
export function useScroll() {
    const context = useContext(ScrollContext);
    if (context === undefined) {
        throw new Error('useScroll must be used within a ScrollProvider');
    }
    return context;
}
export function useOptionalScroll() {
    return useContext(ScrollContext);
}

//# sourceMappingURL=scroll-provider.js.map